import { render, staticRenderFns } from "./AddClientEmployeeOffline.vue?vue&type=template&id=63d2e7a4&"
import script from "./AddClientEmployeeOffline.vue?vue&type=script&lang=js&"
export * from "./AddClientEmployeeOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports